// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f2fd5e97","977":"c5096529"}[chunkId] + ".chunk.js";
};